module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAA60lEQVRIS+2WTQ6CMBBGZyRsekG9hj+g3kBEPYce0LogUKdVSE2EDg00JthVCdM+3tcCRaAmk9VVKTXX/bEaIt5EfllgCFgtoaF43yzVWFbf5v0DB097wpGK/GzilMnaGWtdaxe2jWuN9KeB2kwcjgBR1EgGMVRFARjHnUvRO1JjQt8muU/NxM36lSXIXdpcD2L4sTkIUEeoqP8gGKexDW0Te63gbcaB6RoWUGQngBmCbSKyHKCqKNotl2XqeEB6J/vE1vUELGAvBUexE+gL896lwYC+INe4Cf+eXNH43p9ApMEPwq9jRLij/hMw6MB/gRcUWQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/icon1.png
// module id = irsf
// module chunks = 1